import {useState, useEffect}                            from 'react';
import { SingleSelect }                                 from '../../../lib/iprs-react-library/src/index.js';

/**
 * A React component to allow the user to select a clinician for a booking.
 * It is also possible to change the isVisual flag that dictates whether
 * physitrack needs to be setup for the patient and clinician.
 * Child components can be used to insert other fields such as a 
 * checkbox to limit to just the original clinitian in a reschedule.
 * @param {any} params containing:-
 * clinician: The current clinician.
 * setSelectedUserID: Function to set the current clinician.
 * api: The object used to contact IPRS API.
 * selectedAppointmentTypeID: The current appTypeID.
 * isVisual: If true, the booking must be with a clinician who can handle visual calls
 * I.e. is physitrac enabled.
 * setIsVisual: A function to change the isVisual flag.
 * disabled: If true, the clinician drop down will be disabled.
 * children: Used to add extra fields.
 */
const PersonSelect = ({clinician, setSelectedUserID, api, 
    selectedAppointmentTypeID, isVisual, setIsVisual, disabled, children}) => {


    const [availableUsers, setAvailableUsers] = useState([]);

    const handleVisualChange = e => {

        if(setIsVisual) setIsVisual(e.target.checked);
    };

    useEffect(() => {

        const params = { "FutureAppTypeID": selectedAppointmentTypeID };
        if (isVisual) {
            params.IsVisual = isVisual
        }

        api.transact("DiaryUserList", params)
            .then(result => result.apiResult)
            //.then(users => clinician ? users.filter(u => clinician === u.PartyID) : users)
            .then(r => r.map(u => {
                let title = u?.PartyName;
                title += u?.TeamName ? ' (' + u?.TeamName + ')' : '';
                const partyID = u.PartyID;
                const result = { PartyID: partyID, Title: title };
                return result;
            }))
            .then(r => setAvailableUsers(r))
            .catch(e => console.log(e.apiText));

    }, [selectedAppointmentTypeID, clinician, isVisual, api])

    return <form>

        <h3>Optionally select the clinician</h3>
        <p>Only select a clinician if you need a <em>specific person</em>, for example
            if this is a followup appointment with the same clinician as the initial
            assesment.<br/>
            By leaving this blank, you can let the system choose the first available clinician.

            {children}

        <label htmlFor='selectClinician' >Clinician</label>
        <SingleSelect
                selectableItems={[{ PartyID: 0, Title: 'Select' }, ...availableUsers]}
                selectedItem={clinician}
                setSelectedItem={setSelectedUserID}
                getItemID={u => u.PartyID}
                getItemTitle={u => u.Title}
                name='selectClinician' disabled={disabled} />
        </p>

        {setIsVisual ?
            <>
                <label htmlFor="visualCall" >
                    Is this a visual call
                </label>
                <input type='checkbox' id="visualCall" name='visualCall' checked={isVisual} 
                    onChange={handleVisualChange} disabled={!setIsVisual} />
            </>:
            null
        }
    </form>
}

export default PersonSelect;